import { ADD_DECK, SET_CARDS, TOGGLE_LOADING, SET_ERROR } from './actionType';

const initalState = {
  cards: [],
  isLoading: false,
  error: {},
  deck: []
}

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case ADD_DECK:
      return {
        ...state,
        deck: [...state.deck, action.payload]
      }
    case SET_CARDS:
      return {
        ...state,
        cards: action.payload
      }
    case TOGGLE_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case SET_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default reducer